module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/tooltip-helper.81281aee.svg";